$(function() {
  var closeAll, open, toggle;
  closeAll = function() {
    $('.dropdown').removeClass('open').children('button, a').attr('aria-expanded', false);
    $('.dropdown-dismiss').remove();
  };
  open = function(dropdown) {
    closeAll();
    dropdown.addClass('open');
    dropdown.children('button, a').attr('aria-expanded', true);
    if ('ontouchstart' in document.documentElement) {
      $('<div class=\'dropdown-dismiss\'></div>').on('click', function() {
        return close(dropdown);
      }).insertAfter(dropdown);
    }
  };
  toggle = function(e) {
    var dropdown, isOpen;
    if ($(this).is(':disabled')) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    dropdown = $(this).parents('.dropdown');
    isOpen = dropdown.hasClass('open');
    if (isOpen) {
      return closeAll();
    } else {
      return open(dropdown);
    }
  };
  closeAll();
  $('.dropdown').children('a, button').click(toggle);
  $(document).on('click.cyclops.dropdown', function(event) {
    var dropdown;
    dropdown = $('.dropdown.open');
    return closeAll();
  });
  $.fn.dropdown = function() {
    return this.each(function() {
      return $(this).click(toggle);
    });
  };
});
